


let inpChekElm = document.querySelector('#cus_toggleCheckbox');

async function shippingProdHandler(elmCheckBox, vid ) {
  
  let check;
  
  if(elmCheckBox){
   check = elmCheckBox.checked;
  }
  // let pelm = elmCheckBox.closest('.custom_shipping_wrapper')
  // let qtyElm = pelm.querySelector('.js-qty__wrapper');
  // console.log(qtyElm,'jjjjj')
  // return;

  // document.dispatchEvent(new CustomEvent('cart:quantity' + '.cart-cart-drawer', {
  //             detail: ["53520310894966:90b8226fa6cf68a291f95b96157bdb05", 1, qtyElm]
  // }));

  if(check || !elmCheckBox){
    let formData = {
     'items': [{
      'id': vid,
      'quantity': 1 
      }]
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    var cart = new theme.CartDrawer
    cart.init()
    cart.open();
    // console.log(cart_header_content,'dkdkkdk')
    // $('#' + cart_header_content.id ).load(window.location.href + ' #' + cart_header_content.id + ' > *', () => { console.log('working jfjf') });
     inpChekElm.checked = true; 
    localStorage.setItem('customInpHandleCheck', 'true');
    
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
    
  }else{
    console.log(vid,'vid')
        let updates = {
            [vid]: 0,
          };
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      var cart = new theme.CartDrawer
      cart.init()
      cart.open();
      localStorage.setItem('customInpHandleCheck', 'false');
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

// let cartItems = document.querySelectorAll('.drawer__inner .cart__item');
// console.log(cartItems,'inputChek cartItems');
//     cartItems.forEach(elm=>{
//       let dataKey = elm.getAttribute('data-key');
//       // console.log(dataKey,'data key jj')
//       let myVariantId = dataKey.split(':')[0];
//       if(myVariantId == vid){
//        let inputChek = document.querySelector('.shippingProtectionContainer #cus_toggleCheckbox');
        
//         console.log(inputChek,'inputChek');
//         // console.log(vid,'vid');
//         // elm.style.display = 'none';
//         // console.log('display none sucess')
//       }
//     })

// document.addEventListener('DOMContentLoaded', () => {
//   let cartItems = document.querySelectorAll('.cart__items .cart__item');
//   console.log(cartItems, 'inputChek cartItems');
  
//   cartItems.forEach(elm => {
//     let dataKey = elm.getAttribute('data-key');
//     // console.log(dataKey,'data key jj')
//     let myVariantId = dataKey.split(':')[0];

//     if (myVariantId == vid) {
//       let inputChek = document.querySelector('.shippingProtectionContainer #cus_toggleCheckbox');
//       console.log(inputChek, 'inputChek');
//       // console.log(vid,'vid');
//       // elm.style.display = 'none';
//       // console.log('display none success');
//     }
//   });
// });

// document.addEventListener('cart:change', async function (evt){
//     console.log('cart change jndifn')
// })


let customInpHandleCheck = localStorage.getItem('customInpHandleCheck');

// let inpChekElm = document.querySelector('#cus_toggleCheckbox');
// if(customInpHandleCheck){
//   inpChekElm.setAttribute('checked',true);
// }else{
//   inpChekElm.removeAttribute('checked');
// }

if (customInpHandleCheck == 'true') {
  inpChekElm.checked = true; // Use the checked property to set it to checked
} else {
  inpChekElm.checked = false; // Use the checked property to set it to unchecked
}
// .chat-app .chat-app--close-button-bottom-right {
//   margin-left: 0;
// }
// button.chat-toggle {
//   margin: 0 65px;
// }

// let shopifyChatStyle = setInterval(() => {
//   let shopifyChatElm = document.querySelector("#shopify-chat #ShopifyChat")
//   if (shopifyChatElm && shopifyChatElm.shadowRoot) {
//     shopifyChatElm.shadowRoot.querySelector('.chat-app--close-button-bottom-right').style.marginLeft = 0;
//     shopifyChatElm.shadowRoot.querySelector('button.chat-toggle').style.margin = '0 65px';

//     if(shopifyChatElm.shadowRoot.querySelector('.chat-app--close-button-bottom-right') || shopifyChatElm.shadowRoot.querySelector('button.chat-toggle') ){
//       clearInterval(shopifyChatStyle)
//     }
//   }
// }, 500);

// setTimeout(() => { clearInterval(shopifyChatStyle) }, 10000);


// let rewards = document.querySelector("#chPagebon-loyalty-page");
// let rewards_mob = document.querySelector('a#chPagebon-loyalty-page');
// let rewards_mob = document.querySelector('div.chFlowMobileMenuScroller a#chPagebon-loyalty-page');

// console.log(rewards_mob);
let chatPopup = document.querySelector("#phoneheader");
console.log(chatPopup);

document.addEventListener("click", function(e) {
  console.log("clicked");
  
  if (e.target.closest("a#chPagebon-loyalty-page")) {
    e.preventDefault();
    let rewardsPopup = document.querySelector("#bon-loyalty-btn");
    rewardsPopup.click();
  }
  // if (e.target.closest("chFlowMobileMenuScroller:nth-child(5)")) { 
  //   e.preventDefault();
  //   let chatPopup = document.querySelector("#phoneheader");
  //   console.log(chatPopup);
    
  //   chatPopup.click();
  // }
});


// rewards_mob.addEventListener("click", function(e){
//   e.preventDefault()
//   let rewardsPopup = document.querySelector("#bon-loyalty-btn")
//   rewardsPopup.click()
// })

let livechat = document.querySelector(".chMenuItem-support");

// setTimeout(() => {
//   if(window.innerWidth < 990){
//     let item = document.getElementById('CustomerHubApp').querySelector('.ch-scroll button.chfmms-item[href="#live-chat-js"]');  
//     livechat = item;
//     console.log(item);
//   }
// }, 500);

function chatbox2222(){
  document.getElementById('shopify-chat').style.display = 'block';
  var ccc = document.getElementById('ShopifyChat');
  if (ccc && ccc.shadowRoot) {
    var button = ccc.shadowRoot.querySelector('button.chat-toggle');
    if (button) { button.click() }
    document.getElementById('minihub-launcher-frame').style.right = 'clamp(80px, 11vw, 130px)';
  }
}

livechat?.addEventListener("click", function(e){
  e.preventDefault()
  if(window.innerWidth > 990){
    let chatPopup = document.querySelector("#phoneheader");
    chatPopup.click()
    // chatbox2222();
  }
})

document.addEventListener('click', (e) => {
  let item = e.target;

  if(item.closest('.chfmms-item')){
    let i = item.closest('.chfmms-item').textContent.toLowerCase();

    if(i.includes('live chat')){
      document.getElementById('shopify-chat').style.display = 'block';
      document.getElementById('minihub-launcher-frame').style.right = 'clamp(80px, 11vw, 130px)';
    }
  }
})


